<template>
  <div>
    <!-- 轮播图 -->
    <loop-play-images 
      v-if="bannerImagesData != null"
      :default-classes="defaultClasses"
      :images-data="bannerImagesData"
      :background-appe-mode="false">
    </loop-play-images>
    <div class="rich-text" v-html="content" :style="{minHeight: minHeight}"></div>
  </div>
</template>

<script>
import loopPlayImages from '@/components/loopPlayImages/loopPlayImages.vue'
import bus from '@/utils/eventBus'

export default {
  data() {
    return {
      minHeight: '',
      pageTitle: this.$route.query.pageTitle,
      content: '',
      // 轮播图
      bannerImagesData: null,
      defaultClasses: {
          outerRotateStage: "loopImages",
          rotateStageClass: "loopStage",
          innerShowClass: "loopContainer",
          btnClass: "btnOuter",
          circularClass: "dots"
      }
    }
  },
  components: {
    loopPlayImages
  },
  computed: {

  },
  mounted() {
    this.minHeight = `${document.body.clientHeight + 80}px`
    bus.$emit('updateFooter', this.pageTitle)
    // 获取banner数据
    this.getBannerData()
  },
  methods: {
    // 获取banner数据
    getBannerData() {
      this.$axios({
        url: '/realNet/pageManager/findOne',
        method: 'get',
        headers: { token: "123456789" },
        params: {
            title: this.pageTitle
        }
      }).then(res => {
        this.content = res.data.result.content
        let bannerList = res.data.result.dataMap.bannerList
        this.bannerImagesData = bannerList.map(item => {
          return {
            backgroundImage: item.image,
            imageLinkRouterName: item.link
          }
        })
      }).catch(function(error) {
        console.log(error)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.rich-text {
  width: 90%;
  margin: 0 auto;
  padding: 20px 0px;
}
</style>
